export const FORMAT_VERSION = 1;
export const MODE_FAST = 0;
export const MODE_STRONG = 1;
export const FRESHNESS_WINDOW_S = 60;
export const QR_REFRESH_MS = 10_000;
export const CRED_TTL_S = 604_800;

export const PRESENTATION_DOMAIN = "uh-autentica/p1";
export const ERRAND_DOMAIN = "uh-autentica/r1";
export const STATUS_DOMAIN = "uh-autentica/s1";
export const RENEWAL_DOMAIN = "uh-autentica/n1";
export const RECEIPT_DOMAIN = "uh-autentica/h1";
export const CHALLENGE_DOMAIN = "uh-autentica/c1";
export const HISTORY_DOMAIN = "uh-autentica/q1";
export const LOGOUT_DOMAIN = "uh-autentica/b1";
export const PORTRAIT_DOMAIN = "uh-autentica/f1";

/** Renew once fewer than this many seconds of validity remain. Three days of a
 *  seven-day credential, so a phone that syncs a few times a week never sees
 *  its card expire. */
export const RENEW_BEFORE_S = 3 * 86_400;
/** How long after expiry the issuer still renews. Past it, the holder enrols
 *  again with a password. The issuer enforces the same number. */
export const RENEWAL_GRACE_S = 30 * 86_400;
export const SYNC_INTERVAL_MS = 3_600_000;
/** How long a logout waits on each of its two conversations with the issuer,
 *  the receipt upload and the revocation, before it wipes the device anyway. */
export const LOGOUT_STEP_TIMEOUT_MS = 10_000;
/** The two clock alarms of the original spec: a device this long without a
 *  sync, or whose clock moved this far since the last one. */
export const SYNC_STALE_S = 7 * 86_400;
export const CLOCK_MOVED_S = 300;

export const NONCE_LEN = 8;
export const SIGNATURE_LEN = 64;
/** UTF-8 bytes, not characters, because a QR carries bytes and "á" is two of
 *  them. The fixed ceiling every verifier enforces, in the decoders as
 *  `server/format.py` does; the tighter per-errand budget that holds a
 *  presentation at QR version 26 is the grantor's wallet's to compute. */
export const ERRAND_TEXT_MAX = 140;
export const RECEIPT_NOTE_MAX = 140;
/** Receipts a phone keeps waiting for a sync. A verifier at a door that never
 *  connects fills it in days, and past it the oldest go first: a queue with no
 *  bound is a phone whose storage quota ends the scanning instead. */
export const RECEIPT_QUEUE_MAX = 5_000;
/** Receipts per upload, the most `POST /api/recibos` takes in one request. */
export const RECEIPT_BATCH = 100;

/**
 * Where `vite build` writes its asset manifest, spelled once so the build
 * option and the service worker that reads it cannot drift apart. Not a
 * dotted directory: a static server that hides `.vite/` would 404 it, the
 * service worker would precache nothing but the shell, and the failure would
 * only show up on a phone with no network.
 */
export const ASSET_MANIFEST = "asset-manifest.json";

export const ATTR = {
  ID: 1, NAME: 2, ROLE: 3, DEPARTMENT: 4, FACULTY: 5,
  DEVICE_KEY: 6, ISSUED_AT: 7, EXPIRES_AT: 8, STATUS_INDEX: 9, PORTRAIT: 10,
  PORTRAIT_ORIGIN: 11,
} as const;

/** The value of `ATTR.PORTRAIT_ORIGIN` when the person put the face up and the
 *  UH has not checked it. Absent, the UH stands behind the portrait. */
export const PORTRAIT_BY_HOLDER = 1;
